import { Fragment } from 'react';

import Button from '@/components/Button';
import Tooltip from '@/components/Tooltip';

export function Divider() {
	return <div className="h-6 w-px bg-grey-200" />;
}

export function ButtonsWrapper({ children }) {
	return <div className="flex gap-1">{children}</div>;
}

export function IconButton({
	children,
	className,
	disabled,
	title,
	active,
	...props
}) {
	let Wrapper = Fragment;
	let wrapperProps = {};

	if (title && !disabled) {
		Wrapper = Tooltip;
		wrapperProps = { title, disableHoverableContent: true };
	}

	return (
		<Wrapper {...wrapperProps}>
			<Button
				variant="outline"
				size="iconSm"
				className={className}
				disabled={disabled}
				{...props}
			>
				{children}
			</Button>
		</Wrapper>
	);
}
